module.exports = __webpack_public_path__ + "img/logo-poweredby.7bcee275.png";